import { render } from "./Holiday.vue?vue&type=template&id=8f1d20aa&scoped=true"
import script from "./Holiday.vue?vue&type=script&lang=js"
export * from "./Holiday.vue?vue&type=script&lang=js"

import "./Holiday.vue?vue&type=style&index=0&id=8f1d20aa&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1d20aa"]])

export default __exports__